import ImagePage from './ImagePage'

export default ImagePage